import React, {useEffect, useState} from 'react';
import capitalize from '../../../util/Capitalize';
import {useSelector, useDispatch} from 'react-redux';
// import { ErrorSnackbar, SuccessSnackbar } from "../../../components/CustomSnackBar";
import PageLoader from '../../../components/PageLoader';
import {Button, TablePagination} from '@material-ui/core';
// import { postPrintUsage, resetPrintUsageData } from "../../../../redux/reducers/printUsage";
import GuiTable from '../../../components/FormComponents/GuiTable';
import {ArrowBack} from '@material-ui/icons';
import {defaultRows} from '../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../constants/ReusableConstants';
// import { resetTriggerUsage } from "../../../redux/reducers/EventTactics/EventTactics";
import {resetLetterUsageData} from '../../../redux/reducers/LetterMaintainance/NewLetterMaintenance';
import {modulesText} from '../../../util/Content';


function LetterMaintenanceUsage({lettermaintainanceUsage, setValue}) {
  console.log(lettermaintainanceUsage, 'lettermaintainanceUsage');
  const {isLoading, successMsg, errorMsg, LetterUsageData} = useSelector(
    ({newLetterMaintenance}) => newLetterMaintenance,
  );
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(resetLetterUsageData());
    };
  }, []);

  const [rows, setRows] = useState(defaultRows);

  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);


  const object = LetterUsageData?.placeResponse ? LetterUsageData?.placeResponse : {};

  const values = [];
  object &&
    Object.entries(object)?.forEach(([key, value]) => {
      value?.length > 0 &&
        value?.forEach((el, i) => {
          values.push({
            frameWork: key,
            codes: el?.code,
            description: el?.description ?? '',
          });
        });
    });
  const columns = [
    {
      title: modulesText,
      field: 'frameWork',
      render: (rowData) => {
        return rowData?.frameWork ? capitalize(rowData?.frameWork) : '--';
      },
    },
    {
      title: 'Code',
      field: 'codes',
      render: (rowData) => {
        console.log(rowData, 'renderRowData');
        return rowData?.codes ? rowData?.codes : '--';
      },
    },
    {
      title: 'Description',
      field: 'description',
      render: (rowData) => {
        return rowData?.description ? rowData?.description : '--';
      },
    },
  ];
  return (
    <div className="new-standard-textfields">
      <div className={` mb-0`}>
        <div className="button-table-spacing-mb justify-content-start">
          <Button
            variant="outlined"
            type="button"
            className={`search-btn mx-1`}
            onClick={() => {
              setValue(0);
            }}
          >
            <ArrowBack className="mr-2" />
            Back To Search
          </Button>
        </div>
        <div className="custom-table custom-toolbar-icons global-field-table">
          <GuiTable
            title={`${lettermaintainanceUsage?.letterCode} - ${lettermaintainanceUsage?.letterDescription} This Letter has been used in the following places.`}
            columns={columns}
            data={values}
            textAlign="left"
            options={{
              paging: true,
              toolbar: true,
              search: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
              pageSize: rows,
              pageSizeOptions: tablePageRows,
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer ">
                  <div className="mt-2">
                    {/* <Button
                      type="button"
                      variant="outlined"
                      className={`mx-1 search-btn ${classes.buttonRoot}`}
                      color="primary"
                      disabled={LetterUsageData?.userMetrix === "No"}
                      onClick={(event) => {
                        dispatch(
                          postPrintUsage({
                            baseCategory: "",
                            code: triggerMaintenanceData?.code? triggerMaintenanceData?.code : "",
                            description: triggerMaintenanceData?.description? triggerMaintenanceData?.description : "",
                            displayName: "",
                            fileType: "",
                            recordFormatType: "",
                            returnType: "",
                            sourceType: "TRIGGER MAINTENANCE",
                            isDraft:  "",
                            search:  "",
                            frameworkUsageOrderBy: "",
                            frameworkUsageOrderDerection: "",
                            fieldListOrderBy: "",
                            fieldListOrderDerection: "",
                            category: "",
                            fieldName: "",
                            repositoryDescription: "",
                            repositoryName: "",
                            repositoryType: "",
                            createdBy: "",
                            createdDate:"",
                          })
                        );
                      }}

                    >
                      Download Configuration Usage
                    </Button> */}
                  </div>
                  <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
            }}
          />
        </div>
      </div>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        // <ErrorSnackbar errorMsg={errorMsg || printUsageErrorMsg} />
        {}
      )}
      {(successMsg || printUsageSuccessMsg) && (
        // <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
        {}
      )}
    </div>
  );
}

export default LetterMaintenanceUsage;
